﻿import * as React from 'react';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import format from 'date-fns/format';

type SentLinkInformationLabels = {
    sentTo: string;
};

type SentLinkInformationProps = {
    labels: SentLinkInformationLabels;
    sentToEmail: string;
    linksSentTime: Date;
    links: string[];
};

function SentLinkInformation({
    labels,
    links,
    sentToEmail,
    linksSentTime
}: SentLinkInformationProps) {
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ padding: '14px 16px' }}>
                    {links.map((link, index) => (
                        <Typography
                            key={`${index}__${link}`}
                            variant="body1"
                            sx={{
                                fontSize: '12px',
                                cursor: 'pointer',
                                padding: '4px 0'
                            }}
                        >
                            <Link variant="inherit" sx={{ color: '#0B79D0' }}>
                                {link}
                            </Link>
                        </Typography>
                    ))}
                    <Typography variant="body1" sx={{ fontSize: '12px', padding: '6px 0' }}>
                        {`${labels.sentTo} ${sentToEmail}`}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px' }}
                    >
                        {format(linksSentTime, 'yyyy-MM-dd hh:mm')}
                    </Typography>
                </Box>
            </Box>
        </>
    );
}

export default SentLinkInformation;
